//delete icon button
import React from 'react';
import { cn } from '../../lib/utils';

const IconButton = ({ 
  children, 
  onClick, 
  className = '', 
  disabled = false,
  type = 'button',
  size = 'md', // sm: w-6 h-6, md: w-8 h-8, lg: w-10 h-10
  variant = 'default', // default, danger, success, warning
  icon = null, // SVG icon to display
  ...props 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10'
  };

  const variantClasses = {
    default: 'bg-stone-950/10 hover:bg-red-700',
    danger: 'bg-red-100 hover:bg-red-700',
    success: 'bg-green-100 hover:bg-green-700',
    warning: 'bg-yellow-100 hover:bg-yellow-700'
  };

  const iconColorClasses = {
    default: 'bg-zinc-900 hover:bg-slate-100',
    danger: 'bg-red-600 hover:bg-slate-100',
    success: 'bg-green-600 hover:bg-slate-100',
    warning: 'bg-yellow-600 hover:bg-slate-100'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        // Base styles
        'relative rounded overflow-hidden',
        'transition-all duration-200 ease-in-out',
        'flex items-center justify-center',
        'hover:scale-105 active:scale-95',
        // Size
        sizeClasses[size],
        // Variant colors
        variantClasses[variant],
        // Disabled state
        'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100',
        // Custom className override
        className
      )}
      {...props}
    >
      {icon ? (
        <div className="flex items-center justify-center w-full h-full">
          {icon}
        </div>
      ) : (
        <div className={cn(
          'absolute transition-colors duration-200',
          iconColorClasses[variant],
          size === 'sm' ? 'w-2.5 h-2.5' : size === 'md' ? 'w-3 h-3' : 'w-4 h-4',
          size === 'sm' ? 'left-[7px] top-[7px]' : size === 'md' ? 'left-[10px] top-[10px]' : 'left-[12px] top-[12px]'
        )} />
      )}
      {children}
    </button>
  );
};

export default IconButton;
